// removed by extract-text-webpack-plugin
module.exports = {"UserNote":"UserNote__UserNote__13uSL","note":"UserNote__note__114PV","input":"UserNote__input__lWplj","status":"UserNote__status__sASk5","active":"UserNote__active__3kknC"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/user/UserNote/UserNote.scss
// module id = 322
// module chunks = 0